import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { getAllKeyPersonAction } from "../action/getAllKeyPersonAction";

const initialState: CreateAppData = {
  data: [],
  loading: false,
  error: null,
};

const getAllKeyPersonSlice = createSlice({
  name: "getAllKeyPersonSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllKeyPersonAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllKeyPersonAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.result.result;
      })
      .addCase(getAllKeyPersonAction.rejected, (state, action) => {
        state.loading = false;
        //state.error = action.payload;
      });
  },
});

export const getAllKeyPersonReducer = getAllKeyPersonSlice.reducer;
